<template>
  <div v-if="data && $login.can('subscriptions.view')">
    <page-header :header="data.name" />

    <tabs>
      <tab name="Details">
        <subscription-form
          v-if="canEdit"
          ref="form"
          class="py-3"
          :data="data"
          @save-success="updateSuccess"
        />

        <read-only
          v-else
          :subscription="data"
        />
      </tab>

      <tab name="Users">
        <subscription-users
          ref="users"
          :data="data"
        />
      </tab>
    </tabs>
    <confirm
      v-if="data"
      :name="data.name"
      @confirmed="deleteSubscription"
    />
  </div>
</template>

<script>
import SubscriptionUsers from './Users'
import SubscriptionForm from './Form'
import ReadOnly from './ReadOnly'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import Confirm from '@/components/Confirm'
import {get} from '@/helpers'
import {successNotification, errorNotification} from '@/notifications'

export default {
  components: {
    SubscriptionForm,
    SubscriptionUsers,
    Tabs,
    Tab,
    Confirm,
    ReadOnly,
  },

  metaInfo () {
    return {
      title: this.data ? this.data.name : 'Subscription',
    }
  },

  data () {
    return {
      data: null,
      loading: false,
      error: null,
      dates: null,
      roles: [],
    }
  },

  computed: {
    canEdit () {
      return this.$login.can('subscriptions.update')
    },
  },

  mounted () {
    get(`subscriptions/${this.$route.params.subscriptionId}`)
        .then(this.setData)
  },

  methods: {
    setData (subscription) {
      this.data = subscription.data.data
    },

    updateSuccess () {
      this.$notify(successNotification('Updated successfully'))
      this.$refs.users.getUsers()
    },

    updateFail () {
      this.$notify(errorNotification('Unable to update'))
    },

    deleteSubscription () {
      this.$http
          .delete(`/subscriptions/${this.data.id}`)
          .then(this.deleteSuccess)
          .catch(this.deleteFail)
    },

    deleteSuccess () {
      this.$notify(successNotification(`Deleted ${this.data.name} successfully`))
      this.$router.replace({name: 'subscriptions'})
    },

    deleteFail () {
      this.$notify(errorNotification('Unable to delete'))
    },
  },
}
</script>
